import React, { useState, useEffect } from "react";
import { Badge, Space } from "antd";
import Tags from "./Tags";
const TranslatedText = ({ greekText, englishText }) => {
  const [translatedText, setTranslatedText] = useState("");

  useEffect(() => {
    const lang = document.documentElement.lang;
    if (lang === "el") {
      setTranslatedText(greekText);
    } else {
      setTranslatedText(englishText);
    }
  }, [greekText, englishText]);

  return <span dangerouslySetInnerHTML={{ __html: translatedText }} />;
};
const NameDay = ({ date }) => {
  const [data, setData] = useState([]);
  const [tag, setTag] = useState();
  let uniqueTags;
  useEffect(() => {
    console.log(date);
    let finalDate = date;
    if (date.includes("/")) {
      const FormattedDate = date.split("/");
      finalDate =
        FormattedDate[2] + "-" + FormattedDate[0] + "-" + FormattedDate[1];
    }
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://calendarback.epantokrator.gr/api/holiday/specificDate?date=${finalDate}`
        );
        const data = await response.json();
        setData(data);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [date]);
  // const selectTag = (uniqueTags) => {
  //   setTag(uniqueTags);
  // };

  const dataCollection = ({ data }) => {
    const result = {};

    data.forEach((item) => {
      console.log();

      if (!result[item.date]) {
        result[item.date] = {
          id: item.id,
          date: item.date,
          holidaysEng: item.holidaysEng,
          tags: item.tags,
        };
      }
    });
    let uniqueHolidays;
    console.log(uniqueHolidays);
    const finalResult = Object.values(result);
    console.log(finalResult);
    finalResult.forEach((item) => {
      uniqueTags = [
        ...new Set(data.filter((i) => i.date === item.date).map((i) => i.tags)),
      ];
      uniqueTags = uniqueTags.filter((tag) => tag.trim().length > 0);
      console.log(uniqueTags);

      if (uniqueTags.length === 1) {
        item.tags = uniqueTags[0];
      } else {
        item.tags = "Multiple Tags";
      }
    });
    finalResult.forEach((item) => {
      uniqueHolidays = [
        ...new Set(
          data.filter((i) => i.date === item.date).map((i) => i.holidays)
        ),
      ];
      console.log(uniqueHolidays);
      uniqueHolidays = uniqueHolidays.filter(
        (holidays) => holidays.trim().length > 0
      );
      uniqueHolidays = uniqueHolidays.toString();
      uniqueHolidays = uniqueHolidays.replace(/ ,/g, ", ");
      console.log(uniqueHolidays);
      if (uniqueHolidays.length === 1) {
        item.tags = uniqueHolidays[0];
      } else {
        item.tags = "Multiple Tags";
      }
    });
    return finalResult.map((item) => (
      <div key={item.id}>
        <p
          style={{
            "font-style": "normal",
            "font-weight": "400",
            "font-size": "20px",
            "line-height": "150%",
            fontFamily: "Helvetica Neue",
          }}
        >
          <TranslatedText
            greekText={`<span lang='en'>${uniqueHolidays}</span>`}
            englishText={`<span lang='el'>${item.holidaysEng}</span>`}
          />
        </p>
        {/* <p
          style={{
            "font-style": "normal",
            "font-weight": "400",
            "font-size": "18px",
            "line-height": "150%",
            fontFamily: "Helvetica Neue",
          }}
        >
          <b>
            {" "}
            <TranslatedText
              greekText="<span lang='el'>Γιορτάζουν</span>"
              englishText="<span lang='en'>Celebrate</span>"
            />
          </b>
          : {`${item.names.join(",")}`}
        </p> */}

        <p>{uniqueTags && <Tags tag={uniqueTags} />}</p>
      </div>
    ));
  };

  return (
    <div>
      <div>
        <div>{dataCollection({ data })}</div>
      </div>
    </div>
  );
};

export default NameDay;
